import { map } from '../map'
import { openRoute, setOpenRoute, toMarker, setToMarker, fromMarkers, setFromMarkers } from './index'
import { infoBoxes, clearInfoBoxes, closeInfoBox } from '../utils/infoBox'
import { routes } from '../utils/data/routes'
import { airports } from '../utils/data/airports'
import markerLabel from '../utils/infoBox/templates/markerLabel'
import singleMarker from '../utils/infoBox/templates/singleMarker'
import renderResultList from '../result-list'
import removeLoader from '../utils/loader/removeLoader'
import createLoader from '../utils/loader/createLoader'
import createRoute from '../utils/createRoute'

const handleClick = infoBox => {
  createLoader()

  // click on clustered markers => zoom in and return
  if(infoBox.clusteredMarkers.length > 1) {
    const bounds = new google.maps.LatLngBounds()

    for (let i = 0; i < infoBox.clusteredMarkers.length; i++) {
      bounds.extend(infoBox.clusteredMarkers[i].position)
    }

    map.fitBounds(bounds)

    return
  }

  // if route is opened already, do nothing
  if(openRoute)
    return

  // route is now opened
  setOpenRoute(true)

  // reset prev markers
  setToMarker(null)
  setFromMarkers([])

  // set toMarker
  setToMarker(infoBox.marker)

  // get new bounderies pbject
  const bounds = new google.maps.LatLngBounds()

  // get all routes leading to toMarker (clicked marker)
  const currentRoutes = routes.filter(route => route.to === toMarker.iata ? true : false)

  const departures = []
  // TODO: rewrite to filter() method
  // sort only markers (airports) that leading to toMarker (clicked marker), no duplicated
  for (let i = 0; i < airports.length; i++) {
    for (let j = 0; j < currentRoutes.length; j++) {
      if(airports[i].id === currentRoutes[j].fromId) {
        if(departures.length === 0) {
          departures.push(airports[i])
        } else {
          let inArray = false
          for (let k = 0; k < departures.length; k++) {
            if(departures[k].id === airports[i].id)
              inArray = true
          }

          if(!inArray)
            departures.push(airports[i])
        }
      }
    }
  }

  setFromMarkers(departures)

  renderResultList(currentRoutes)

  // clear all infoBoxes
  for (let i = 0; i < infoBoxes.length; i++) {
    closeInfoBox(infoBoxes[i])
  }
  clearInfoBoxes()

  // create routes
  createRoute(toMarker, fromMarkers, bounds)

  // zoom map to visible points (opened routes)
  map.fitBounds(bounds)

  setTimeout(function() {
    removeLoader()
  }, 0)
}

export default handleClick


// http://jsfiddle.net/upsidown/2wej9smf/
// http://jsfiddle.net/geocodezip/3b3j61pq/4/
// http://jsbin.com/momom/1/edit?html,output



// WEBPACK FOOTER //
// ./app/markers/handleClick.js